import { App } from './App';

App.format = {
    init() {
        if (document.querySelectorAll('.input-calendar:not(.input-calendar-no-format)').length) App.format.date();
        if (document.querySelectorAll('.input-currency').length) App.format.currency();
        if (document.querySelectorAll('.input-currenct-no-decimal').length) App.format.currencyWithoutDecimal();
        if (document.querySelectorAll('.input-number').length) App.format.number();
    },
    date() {
        document.querySelectorAll('.input-calendar:not(.input-calendar-no-format)').forEach(input => {
            input.cleave = new Cleave(input, {
                date: true,
                datePattern: ['d', 'm', 'Y'],
                delimiter: '.'
            });
        });
    },
    currency() {
        document.querySelectorAll('.input-currency').forEach(input => {
            input.cleave = new Cleave(input, {
                numeral: true,
                numeralDecimalMark: ',',
                delimiter: '.'
            });
        });
    },
    currencyWithoutDecimal() {
        document.querySelectorAll('.input-currenct-no-decimal').forEach(input => {
            input.cleave = new Cleave(input, {
                numeral: true,
                numeralDecimalMark: ',',
                delimiter: '.',
                numeralDecimalScale: 0
            });
        });
    },
    number() {
        document.querySelectorAll('.input-number').forEach(input => {
            input.cleave = new Cleave(input, {
                numeral: true,
                numeralDecimalMark: ',',
                delimiter: ''
            });
        });
    }
};
